import { render, staticRenderFns } from "./supportUnit.vue?vue&type=template&id=0b0750a4&scoped=true&"
import script from "./supportUnit.vue?vue&type=script&lang=js&"
export * from "./supportUnit.vue?vue&type=script&lang=js&"
import style0 from "./supportUnit.vue?vue&type=style&index=0&id=0b0750a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0750a4",
  null
  
)

export default component.exports